import React, { useEffect, useState, useContext } from "react";
import "../styles/Profile.css";
import { UserContext } from "../context/User";
import { useHistory } from "react-router-dom";
import { PencilSimple, Heart } from "phosphor-react";
import { createStyles, Paper, Text, Title, Button } from "@mantine/core";
import axios from "axios";
import { petdata } from "../data";

const useStyles = createStyles((theme) => ({
  card: {
    height: 440,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },

  title: {
    fontFamily: `Greycliff CF ${theme.fontFamily}`,
    fontWeight: 900,
    color: theme.white,
    lineHeight: 1.2,
    fontSize: 32,
    marginTop: theme.spacing.xs,
  },

  category: {
    color: theme.white,
    opacity: 0.7,
    fontWeight: 700,
    textTransform: "uppercase",
  },
}));
const Profile = () => {
  const [liked, setliked] = useState([]);
  const [data, setdata] = useState([]);
  const matches = [4, 12, 16, 28, 32, 40, 44, 52, 56, 64, 68, 76];
  useEffect(() => {
    axios
      .get("https://swipett.herokuapp.com/likeuser/likedusers", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setliked(res.data.likedusers);
        setdata(
          petdata.filter((item) => res.data.likedusers.includes(item.id))
        );
      });
  }, []);
  const { classes } = useStyles();

  const history = useHistory();
  const { isLoggedIn, UserInfo } = useContext(UserContext);

  return (
    <>
      <div className="profile">
        <div className="p-main">
          <div>
            <img
              className="p-image"
              src={
                UserInfo.avatar
                  ? UserInfo.avatar
                  : `https://ui-avatars.com/api/?background=008AB8&color=fff&name=${UserInfo.username.charAt(
                      0
                    )}&size=128`
              }
              alt=""
            />
          </div>
          <div className="p-name">{UserInfo.username}</div>
          <div className="p-desc">{UserInfo.desc}</div>
          <Button
            color="gray"
            style={{ marginTop: "20px" }}
            radius="xl"
            size="sm"
            onClick={() => {
              history.push("/completeprofile");
            }}
            leftIcon={<PencilSimple size={22} weight="bold" />}
          >
            Edit Profile
          </Button>
          <Button
            color="red"
            style={{ marginTop: "20px" }}
            radius="xl"
            size="sm"
            onClick={() => {
              history.push("/home");
            }}
            leftIcon={<Heart size={22} weight="bold" />}
          >
            Start swiping
          </Button>
        </div>
      </div>
      <Title style={{ color: "gold" }} align="center" order={1} mt={30}>
        {data.length > 0 ? "💛 Your Matches" : "💛 No Matches yet"}
      </Title>
      <div className="likes">
        {data
          .filter((val) => {
            return matches.includes(val.id);
          })
          .map((n, i) => {
            return (
              <Paper
                style={{
                  border: "4px solid yellow",
                  maxWidth: "300px",
                  height: "300px",
                  flex: "auto",
                  borderRadius: "50%",
                  width: "100%",
                }}
                shadow="md"
                p="xl"
                sx={{
                  backgroundImage: `url(${n.url})`,
                }}
                className={classes.card}
              >
                <div>
                  <Text className={classes.category} size="xs"></Text>
                  <Title
                    style={{ backgroundColor: "black", padding: "10px" }}
                    order={3}
                    className={classes.title}
                  >
                    {n.name}
                  </Title>
                </div>
              </Paper>
            );
          })}
      </div>

      <Title style={{ color: "red" }} align="center" order={1} mt={30}>
        {data.length > 0 ? "❤️ Your Likes" : "❤️ No Likes yet"}
      </Title>

      <div className="likes">
        {data
          .filter((val) => {
            return !matches.includes(val.id);
          })
          .map((n, i) => {
            return (
              <Paper
                style={{
                  border: "4px solid red",

                  maxWidth: "300px",
                  height: "300px",
                  flex: "auto",
                  width: "100%",
                  borderRadius: "50%",
                }}
                shadow="md"
                p="xl"
                radius="md"
                sx={{
                  backgroundImage: `url(${n.url})`,
                }}
                className={classes.card}
              >
                <div>
                  <Text className={classes.category} size="xs"></Text>
                  <Title
                    style={{ backgroundColor: "black", padding: "10px" }}
                    order={3}
                    className={classes.title}
                  >
                    {n.name}
                  </Title>
                </div>
              </Paper>
            );
          })}
      </div>
    </>
  );
};

export default Profile;
